const variablesByEnvironments: {
  [key: string]: {
    urlApiPlataforma: string;
    urlApiCadastro: string;
    urlApiGateway: string;
    urlApiWorkflowIntegracao?: string;
    urlApiIntegracao?: string;
    ambiente: string;
  };
} = {
  topocartDev: {
    urlApiPlataforma: "https://api.topocart.dev.br/plataforma",
    urlApiCadastro: "https://api.topocart.dev.br/cadastro",    
    urlApiGateway: "https://api.topocart.dev.br/gateway",
    urlApiWorkflowIntegracao: "https://workflows.desenvolvimento.topocart.dev.br/webhook",
    urlApiIntegracao: "https://integracao-api.desenvolvimento.topocart.dev.br",
    ambiente: "Ambiente de Desenvolvimento - Topocart",
  },
  portoVelho: {
    urlApiPlataforma: "https://plataforma-geo360.portovelho.ro.gov.br",
    urlApiCadastro: "https://cadastro-geo360.portovelho.ro.gov.br",
    urlApiGateway: "https://gateway-geo360.portovelho.ro.gov.br",
    ambiente: "Porto Velho",
  },
  alexania: {
    urlApiPlataforma: "https://plataforma-geo360.alexania.go.gov.br",
    urlApiCadastro: "https://cadastro-geo360.alexania.go.gov.br",
    urlApiGateway: "https://gateway-geo360.alexania.go.gov.br",
    ambiente: "Alexania",
  },
  goiania: {
    urlApiPlataforma: "https://apis-goiania.geo360.com.br/plataforma",
    urlApiCadastro: "https://apis-goiania.geo360.com.br/cadastro",
    urlApiGateway: "https://apis-goiania.geo360.com.br/openrest",
    ambiente: "Goiania",
  },
  manaus: {
    urlApiPlataforma: "https://plataforma-geo360.manaus.am.gov.br",
    urlApiCadastro: "https://cadastro-geo360.manaus.am.gov.br",
    urlApiGateway: "https://gateway-geo360.manaus.am.gov.br",
    ambiente: "Manaus",
  },
  next: {
    urlApiPlataforma: "https://plataforma.geo360.dev",
    urlApiCadastro: "https://cadastro.geo360.dev",
    urlApiGateway: "https://gateway.geo360.dev",
    ambiente: "Ambiente de Homologação",
  },
  mesquita: {
    urlApiPlataforma: "https://plataforma.geo360.com.br",
    urlApiCadastro: "https://cadastro.geo360.com.br",
    urlApiGateway: "https://api-gateway.geo360.com.br",
    urlApiWorkflowIntegracao: "https://workflows-integracao.topocart.dev.br/webhook",
    urlApiIntegracao: "https://integracao-api.topocart.dev.br",
    ambiente: "eTopocart",
  },
};

export const environments = variablesByEnvironments[process.env.REACT_APP_AMBIENTE || "topocartDev"];
export const socketToken = process.env.REACT_APP_SOCKET_TOKEN